import { h, defineComponent } from 'vue';
import { SubscribePageCb } from '@/ui/pages/subscription/Chargebee/subscribe/SubscribePage';

export const SubscribePage = defineComponent({
  name: 'SubscribePage',
  setup() {
    return function render() {
      return h(SubscribePageCb);
    };
  },
});
